// Les ISOs du dossier, sur la carte (V4DossierIsos).
export default {
  titre: 'ISOs',
  sousTitre: 'Les sous-jumeaux des marques de {nom}, tirés de leurs audiences mesurées : ils sortent chaque jour et rapportent',
  ceDossier: 'ce dossier',
  fermer: 'fermer',
  fermerTitre: 'Fermer',
  chargement: 'chargement…',
  choisirDossier: 'Choisissez un dossier : ses ISOs sont ceux de toutes ses marques.',
  carte: 'Les ISOs du dossier sur la carte',
  paysTerritoires: '{pays} : {liste}',
  lien: '{a} ↔ {b} : {sujets}',
  mode: {
    arene: 'Arène',
    grille: 'Grille',
  },
  phrase: {
    arene: 'Tout converge vers les marques : leurs ISOs regardent leurs chaînes et vont écouter ce qui se dit d’elles, là où ils traînent.',
    grille: 'Aucune focale : les ISOs vivent leur journée médiatique dans les territoires du dossier. On voit ce qui existe autour des marques.',
  },
  erreur: {
    flottes: 'Flottes illisibles',
    reglage: 'Réglage impossible',
  },
  quand: {
    aujourdhui: 'aujourd’hui vers {heure}',
    demain: 'demain vers {heure}',
    jour: '{jour} vers {heure}',
  },
  annonce: {
    activee: 'Flotte {nom} activée : la première part maintenant, puis chaque jour toute seule, à l’heure de la patrouille d’Orion. Ce qu’elle rapporte apparaît aussi dans Sentinel, couche Marques.',
    prochaine: 'Pris en compte à la prochaine flotte, {quand}. Celle d’aujourd’hui termine sa journée avec l’ancien réglage.',
    eteinte: 'Flotte {nom} éteinte : aucune nouvelle ne partira.',
    eteinteJour: 'Flotte {nom} éteinte : aucune nouvelle ne partira. Celle d’aujourd’hui termine sa journée.',
    enregistre: 'Enregistré : rien ne change pour la flotte du jour.',
    nePartPas: '{nom} ne part pas.',
    nePartPasCar: '{nom} ne part pas : {raison}.',
  },
  etat: {
    eteinte: 'éteinte',
    jamais: 'jamais activée',
    enVol: 'en vol · {fait}/{total} sessions',
    prochaine: 'prochaine flotte {quand}',
    active: 'active',
  },
  raison: {
    miniature_attrayante: 'la miniature',
    titre: 'le titre',
    createur_connu: 'un créateur connu',
    sujet: 'le sujet',
  },
  activation: {
    titre: 'flottes quotidiennes',
    fermerParametres: 'Fermer les paramètres',
    ouvrirParametres: 'Effectif et territoires ciblés',
    parametres: 'Paramètres',
    isosJour: '{n} ISOs/jour',
    eteindre: 'Éteindre : plus aucune flotte ne partira',
    sansPersonas: 'Il faut d’abord les personas des marques : leurs ISOs sont leurs sous-jumeaux',
    sansCible: 'Choisissez au moins un territoire pour une marque, dans les paramètres',
    activer: 'Activer : la première flotte part maintenant, puis chaque jour',
    personasDabord: 'Les ISOs sont les sous-jumeaux des marques : il faut d’abord leurs personas. Un audit de chaque marque les calcule.',
  },
  voient: {
    titre: 'ce que vos ISOs voient',
    jourObserve: 'jour observé {jour}',
    septJours: '7 jours',
    rienEncore: 'Rien encore : la première flotte n’est pas rentrée. Un sujet doit être vu pour apparaître ici, et persister pour monter.',
    aucuneFlotte: 'Aucune flotte active. Activez l’Arène ou la Grille : leurs ISOs sortiront chaque jour, et ce qu’ils voient remontera ici, et dans Sentinel (couche Marques).',
    monte: 'ce qui monte',
    sujet: '{sujet} : {territoire}, {mode} · poids neuf {poids} · vu {jours} jour(s)',
    sujetMarque: '{sujet} : {territoire}, {mode}, {marque} · poids neuf {poids} · vu {jours} jour(s)',
    traverse: 'ce qui traverse vos territoires',
    prevus: 'prévus, pas encore sortis',
  },
  parametres: {
    titre: 'paramètres',
    sansPersonas: 'Pas encore de personas : ses ISOs sont ses sous-jumeaux, personne ne part. Un audit de la marque les calcule.',
    parTerritoire: 'ISOs par territoire',
    propose: 'proposé : {n}',
    revenir: 'revenir',
    cibles: 'territoires ciblés',
    aussiPorte: 'Aussi porté par {liste} : chacune y envoie ses ISOs',
    aucunTerritoireMarque: 'Aucun territoire : ils se détectent à l’audit de la marque.',
    cout: "≈ {jour} {'$'} par jour · {mois} {'$'} par mois",
    dossier: 'dossier',
    coutMesure: 'Coût mesuré sur les sorties réelles.',
    coutEstime: 'Estimation, avant la première mesure.',
    aucunTerritoire: 'Aucun territoire : ils se détectent à l’audit des marques du dossier.',
    sansMarqueUn: '{liste} : ouvert au dossier, mais aucune marque ne le porte, donc aucun ISO de marque n’y va.',
    sansMarquePlusieurs: '{liste} : ouverts au dossier, mais aucune marque ne le porte, donc aucun ISO de marque n’y va.',
    enAttente: 'La flotte du jour est partie avec l’ancien réglage : le nouveau vaudra pour la prochaine, {quand}.',
    indiceAppliquer: 'Enregistre l’effectif et les territoires de chaque marque',
    appliquer: 'Appliquer',
    prochaine: 'vaudra pour la prochaine flotte si celle du jour est partie',
  },
  fiche: {
    portePar: 'porté par {liste}',
    isosLe: '· {n} ISOs le {jour}',
    sansSignal: '· {pct} % sans signal',
    monte: 'monte',
    apparait: 'apparaît',
    tient: 'tient',
    createurs: 'créateurs',
    cliquent: 'ils cliquent pour',
    ecarts: 'perçu vs attendu',
    cible: 'Ciblé : la première flotte n’est pas encore rentrée.',
    aucun: 'Pas d’ISO de ce mode sur ce territoire.',
  },
  sansLieu: 'sans lieu sur la carte : {liste}',
}
